import { PaginationAndColumnVisibilityHoc } from "@shared/components";
import { ColumnOptions, DefaultHiddenColumns } from "../utils/constants";
import PartnersHeader from "../components/PartnersHeader";
import { PartnersProps } from "../utils/types";
import PartnersDataGrid from "../components/PartnersDataGrid";

const Partners = ({
  visibleColumns,
  setVisibleColumns,
  paginationModel,
  setPaginationModel,
}: PartnersProps) => {
  return (
    <>
      <PartnersHeader
        visibleColumns={visibleColumns}
        setVisibleColumns={setVisibleColumns}
      />
      <PartnersDataGrid
        paginationModel={paginationModel}
        setPaginationModel={setPaginationModel}
        visibleColumns={visibleColumns}
      />
    </>
  );
};

const transformedColumnOptions = ColumnOptions.map((option) => ({
  ...option,
  field: option.value,
}));

const TransformedPartners = PaginationAndColumnVisibilityHoc(Partners, {
  columnOptions: transformedColumnOptions,
  defaultHiddenColumns: DefaultHiddenColumns,
  storageKey: "partnersVisibleColumns",
});

export default TransformedPartners;
